import * as React from 'react'
import {
    Container,
    Grid2,
    MenuItem,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Typography
} from '@mui/material'

import Navbar from '../setup/Navbar'
import HeadingText from '../../BuiltInComponent/HeadingTest'
import ButtonNormal from '../../BuiltInComponent/ButtonNormal'
import { useDispatch, useSelector } from 'react-redux'
import { getProductionItems, getStockLedger } from '../../features/AdminManagement/productionSlice'

export default function StockLedger() {
    const dispatch = useDispatch()
    const { items, ledger } = useSelector((state) => state.production)

    const [filter, setFilter] = React.useState({
        branchID: 1,
        itemCode: '',
        movementType: '',
        fromDate: '',
        toDate: ''
    })

    React.useEffect(() => {
        dispatch(getProductionItems())
        dispatch(getStockLedger({ branchID: 1 }))
    }, [dispatch])

    const onSearch = () => {
        const payload = {
            branchID: filter.branchID,
            itemCode: filter.itemCode || undefined,
            movementType: filter.movementType || undefined,
            fromDate: filter.fromDate || undefined,
            toDate: filter.toDate || undefined
        }
        dispatch(getStockLedger(payload))
    }

    return (
        <>
            <Navbar />
            <Container sx={{ mt: 2, mb: 4 }}>
                <HeadingText text='Item Stock Ledger' />

                <Paper variant='outlined' sx={{ p: 2, mt: 2 }}>
                    <Grid2 container spacing={2}>
                        <Grid2 size={{ xs: 12, md: 2 }}>
                            <TextField
                                label='Branch ID'
                                type='number'
                                fullWidth
                                size='small'
                                value={filter.branchID}
                                onChange={(e) => setFilter((p) => ({ ...p, branchID: e.target.value }))}
                            />
                        </Grid2>
                        <Grid2 size={{ xs: 12, md: 3 }}>
                            <TextField
                                select
                                label='Item'
                                fullWidth
                                size='small'
                                value={filter.itemCode}
                                onChange={(e) => setFilter((p) => ({ ...p, itemCode: e.target.value }))}
                            >
                                <MenuItem value=''>All</MenuItem>
                                {items.map((item) => (
                                    <MenuItem key={item.itemCode} value={item.itemCode}>
                                        {item.itemCode} - {item.itemDesc}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid2>
                        <Grid2 size={{ xs: 12, md: 3 }}>
                            <TextField
                                select
                                label='Movement Type'
                                fullWidth
                                size='small'
                                value={filter.movementType}
                                onChange={(e) => setFilter((p) => ({ ...p, movementType: e.target.value }))}
                            >
                                <MenuItem value=''>All</MenuItem>
                                <MenuItem value='purchase_in'>purchase_in</MenuItem>
                                <MenuItem value='production_in'>production_in</MenuItem>
                                <MenuItem value='production_out'>production_out</MenuItem>
                                <MenuItem value='sale_out'>sale_out</MenuItem>
                                <MenuItem value='wastage'>wastage</MenuItem>
                                <MenuItem value='adjustment'>adjustment</MenuItem>
                            </TextField>
                        </Grid2>
                        <Grid2 size={{ xs: 12, md: 2 }}>
                            <TextField
                                label='From'
                                type='date'
                                fullWidth
                                size='small'
                                value={filter.fromDate}
                                onChange={(e) => setFilter((p) => ({ ...p, fromDate: e.target.value }))}
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid2>
                        <Grid2 size={{ xs: 12, md: 2 }}>
                            <TextField
                                label='To'
                                type='date'
                                fullWidth
                                size='small'
                                value={filter.toDate}
                                onChange={(e) => setFilter((p) => ({ ...p, toDate: e.target.value }))}
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid2>
                        <Grid2 size={{ xs: 12, md: 2 }}>
                            <ButtonNormal onClick={onSearch} text='Apply Filter' />
                        </Grid2>
                    </Grid2>
                </Paper>

                <Paper variant='outlined' sx={{ p: 2, mt: 2 }}>
                    <Typography sx={{ fontWeight: 700, mb: 1 }}>Ledger Entries</Typography>
                    <TableContainer sx={{ maxHeight: 620 }}>
                        <Table size='small' stickyHeader>
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: 700 }}>Time</TableCell>
                                    <TableCell sx={{ fontWeight: 700 }}>Item</TableCell>
                                    <TableCell sx={{ fontWeight: 700 }}>Type</TableCell>
                                    <TableCell sx={{ fontWeight: 700 }} align='right'>Qty</TableCell>
                                    <TableCell sx={{ fontWeight: 700 }}>Ref</TableCell>
                                    <TableCell sx={{ fontWeight: 700 }}>Remarks</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {ledger.map((row) => (
                                    <TableRow key={row.ledgerID}>
                                        <TableCell>{row.recordedAt}</TableCell>
                                        <TableCell>{row.itemDesc}</TableCell>
                                        <TableCell>{row.movementType}</TableCell>
                                        <TableCell align='right' sx={{ color: Number(row.quantity) < 0 ? '#d84315' : '#1b5e20', fontWeight: 700 }}>
                                            {Number(row.quantity || 0).toFixed(3)}
                                        </TableCell>
                                        <TableCell>{row.referenceType} #{row.referenceID}</TableCell>
                                        <TableCell>{row.remarks}</TableCell>
                                    </TableRow>
                                ))}
                                {ledger.length === 0 && (
                                    <TableRow>
                                        <TableCell colSpan={6} align='center'>No records found</TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            </Container>
        </>
    )
}
